<div id="manage-user">
  <p class="TXT_TITLE">:: Manage User ::</p>
  <div
    class="manage-add-user"
    style="display: flex; justify-content: space-between; align-items: center"
  >
    <div>
      <button nz-button nzType="default" (click)="addNewUser()">
        <img
          class="iconImage"
          src="../../../../assets/icons/new.gif"
          alt="New Item Icon"
        />
        <span class="textColor ml">Add New User</span>
      </button>
    </div>
    <div class="manage-search-user" style="margin-right: 20px">
      <div style="position: relative; width: 232px">
        <input
          nz-input
          placeholder="Search by name, email, or office..."
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchUser()"
          style="width: 248px; padding-right: 28px"
          type="text"
        />
        <span
          *ngIf="searchText"
          (click)="searchText = ''; onSearchUser()"
          style="
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            color: #aaa;
            font-size: 8px;
          "
          title="Clear"
          >&#10005;</span
        >
      </div>
    </div>
  </div>

  <!-- User Grid -->
  <nz-table
    class="StyleTable"
    #usersData
    [nzData]="filteredUsers"
    nzBordered
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageNumber"
    [nzShowSizeChanger]="true"
    [nzPageSizeOptions]="[10, 20, 50, 100]"
    (nzPageSizeChange)="onPageSizeChange($event)"
    (nzPageIndexChange)="onPageIndexChange($event)"
    [nzNoResult]="customNoDataMessage"
  >
    <thead>
      <tr>
        <th></th>
        <th>User Name</th>
        <th>E-Mail</th>
        <th>Purchasing Office</th>
        <th>Status</th>
        <th>User Role</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of usersData.data; let i = index">
        <td class="action-col">
          <button nz-button nzType="text" (click)="editUserDetails(user)">
            <img
              src="assets/icons/edit.gif"
              alt="Edit"
              width="14"
              height="14"
            />
          </button>
        </td>
        <td class="text-left">{{ user.userName }}</td>
        <td class="text-left">
          <a href="mailto:{{ user.email }}">{{ user.email }}</a>
        </td>
        <td>{{ user.purchasingOffice }}</td>
        <td>{{ user.status ? "Active" : "Inactive" }}</td>
        <td>
          <span>{{ userRoles(user) }}</span>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <!-- Popup for create new User -->
  <div class="popupStyle" *ngIf="showUserPopup">
    <div class="popup" (click)="closePopup()">
      <div class="popup-content" (click)="$event.stopPropagation()">
        <div class="popup-header">
          <p class="TXT_TITLE">
            : : Manage User : : {{ isEditMode ? "Edit User" : "Add User" }}
          </p>
          <span class="close" (click)="closePopup()">&times;</span>
        </div>
        <div class="popup-body">
          <div>
            <form [formGroup]="userForm" class="user-form">
              <label><i class="asterisk">*</i>Status:</label>
              <nz-select formControlName="status">
                <nz-option nzLabel="Active" nzValue="true"></nz-option>
                <nz-option nzLabel="Inactive" nzValue="false"></nz-option>
              </nz-select>

              <div
                class="error"
                *ngIf="
                  userForm.get('status')?.invalid &&
                  userForm.get('status')?.touched
                "
              >
                Status is required.
              </div>
              <label><i class="asterisk">*</i>E-Mail:</label>
              <input
                nz-input
                placeholder="Enter Email"
                formControlName="email"
                (focus)="onFocus()"
                (mouseout)="getDetailsByEmail()"
                type="email"
              />

              <div
                class="error"
                *ngIf="
                  userForm.get('email')?.invalid &&
                  userForm.get('email')?.touched
                "
              >
                <span *ngIf="userForm.get('email')?.errors?.['required']"
                  >Email is required.</span
                >
                <span *ngIf="userForm.get('email')?.errors?.['email']"
                  >Invalid email format.</span
                >
              </div>

              <label><i class="asterisk">*</i>First Name:</label>
              <input
                nz-input
                placeholder="Enter First Name"
                formControlName="firstName"
                type="text"
                readonly
              />

              <label><i class="asterisk">*</i>Last Name: </label>
              <input
                nz-input
                placeholder="Enter Last Name"
                formControlName="lastName"
                type="text"
                readonly
              />

              <label><i class="asterisk">*</i>Purchasing Office:</label>

              <nz-select formControlName="purchasingOffice">
                <nz-option
                  *ngFor="let office of purchasingOffices"
                  nzValue="{{ office.id }}"
                  nzLabel="{{ office.name }}"
                >
                </nz-option>
              </nz-select>

              <div
                class="error"
                *ngIf="
                  userForm.get('purchasingOffice')?.invalid &&
                  userForm.get('purchasingOffice')?.touched
                "
              >
                Purchasing Office is required.
              </div>

              <label><i class="asterisk">*</i>User Role:</label>
              <div nz-row [formGroup]="addUserTypeGroup">
                <div nz-col nzSpan="7">
                  <div class="role-options">
                    <label> System Admin</label>
                    <div nz-col nzSpan="4">
                      <input type="checkbox" formControlName="systemAdmin" />
                    </div>
                  </div>
                </div>

                <div nz-col nzSpan="7">
                  <div class="role-options">
                    <label> Lead Buyer</label>
                    <div nz-col nzSpan="4">
                      <input type="checkbox" formControlName="leadBuyer" />
                    </div>
                  </div>
                </div>

                <div nz-col nzSpan="7">
                  <div class="role-options">
                    <label> Buyer</label>
                    <input type="checkbox" formControlName="buyer" />
                  </div>
                </div>
              </div>
              <!-- Optionally, require at least one role -->

              <div
                class="error"
                *ngIf="addUserTypeGroup.invalid && addUserTypeGroup.touched"
              >
                At least one user role is required.
              </div>

              <div class="mt-15">
                <button
                  type="submit"
                  nz-button
                  nzType="primary"
                  *ngIf="!isEditMode"
                  (click)="addUser()"
                  [disabled]="userForm.invalid"
                >
                  Add
                </button>
                <button
                  type="submit"
                  nz-button
                  nzType="primary"
                  *ngIf="isEditMode"
                  (click)="updateUserDetails()"
                  [disabled]="userForm.invalid"
                >
                  Save
                </button>
                <button
                  type="button"
                  nz-button
                  nzType="primary"
                  nzDanger
                  (click)="deleteUser()"
                  class="ml-15"
                  *ngIf="isEditMode"
                >
                  Delete
                </button>
                <button
                  type="button"
                  nz-button
                  nzType="default"
                  (click)="closePopup()"
                  class="ml-15"
                >
                  Back
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
